import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M14 7l-5 5 5 5V7z" />, 'ArrowLeft');
